export function hasSavedColumns(cookies) {
	return Boolean(cookies.get('columns'));
}

export function restoreDefaultColumns(cookies, defaultColumns) {
	cookies.remove('columns', { path: '/' });
	return defaultColumns.slice();
}

export function openDetailsForRow(rows, rowIdx, onOpen) {
	const row = rows[rowIdx];
	if (!row || !row.txnID) return false;
	onOpen(row);
	return true;
}
